import React from 'react';
import createForm from "../Form";
import ComponentField from "../../../form/ComponentField";
import DateTimeInput from "../../../form/DateTimeInput";
import CheckBox from "../../../form/CheckBox";
import Select from "../../../form/Select";
import LoyaltyPointDiscountRuleConditions from "./LoyaltyPointDiscountRuleConditions";
import TypeTextEditor from '../../../form/TypeTextEditor';
import Figures from '../../../form/Figures';
import UrlField from '../../../form/UrlField';

class LoyaltyPointDiscountRuleForm extends React.Component {

    render() {
        const conditionProps = {
            name: "conditions",
            value: typeof this.props.values.conditions === "string" ? JSON.parse(this.props.values.conditions) : this.props.values.conditions,
            saveChanges: this.props.setFieldValue
        };
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Név"
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <Select
                            {...this.props.getFieldProps("component_type")}
                            optionname="LoyaltyPointDiscountComponent"
                            storeType="local"
                            objectValue={false}
                            name="component_type"
                            value={this.props.values.component_type}
                            label="Célkomponens"
                            saveChanges={this.props.setFieldValue}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("start_date")}
                            isClearable={true}
                            maxDate={this.props.values.end_date}
                            name="start_date"
                            value={this.props.values.start_date}
                            label="Kezdés"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                    <div className="col-sm-4">
                        <DateTimeInput
                            {...this.props.getFieldProps("end_date")}
                            isClearable={true}
                            minDate={this.props.values.start_date}
                            name="end_date"
                            value={this.props.values.end_date}
                            label="Vég"
                            showTime={true}
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-4">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="calculation_value"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Pontszámítás értéke"
                            required={true}
                        />
                    </div>
                    <div className="col-sm-4">
                        <Select
                            {...this.props.getFieldProps("calculation_type")}
                            optionname="LoyaltyPointDiscountRuleCalculationType"
                            storeType="local"
                            objectValue={false}
                            name="calculation_type"
                            value={this.props.values.calculation_type}
                            label="Pontszámítás típusa"
                            saveChanges={this.props.setFieldValue}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-4">
                        {
                            this.props.values.component_type &&
                            this.props.values.calculation_type == "percentage" &&
                            <Select
                                {...this.props.getFieldProps("calculation_field")}
                                optionname="LoyaltyPointDiscountComponentField"
                                filter={[
                                    {
                                        field: "xtradata",
                                        operator: "like",
                                        value: this.props.values.component_type
                                    }
                                ]}
                                storeType="local"
                                objectValue={false}
                                name="calculation_field"
                                value={this.props.values.calculation_field}
                                label="Pontszámítás alapja"
                                saveChanges={this.props.setFieldValue}
                                required={true}
                            />
                        }
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <CheckBox
                            {...this.props.getFieldProps("additive")}
                            name="additive"
                            value={this.props.values.additive}
                            label="Hozzáadódó kedvezmény"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <LoyaltyPointDiscountRuleConditions {...conditionProps} disabled={this.props.isLoading} component_type={this.props.values.component_type}/>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <TypeTextEditor
                            name="description"
                            label="Leírás"
                            data={this.props.values}
                            componentConfig={this.props.componentConfig}
                            getFieldProps={this.props.getFieldProps}
                            setFieldValue={this.props.setFieldValue}
                        />
                    </div>
                </div>
                <div className="row form-row">
                {this.props.componentConfig.fielddefs.url && <UrlField {...this.props}/>}
                    <div className="col-sm-12">
                        <Figures
                            name="images"
                            label="Képek"
                            componentConfig={this.props.componentConfig}
                            data={this.props.values}
                        />
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-sm-12">
                        <CheckBox
                            {...this.props.getFieldProps("public")}
                            name="public"
                            value={this.props.values.public}
                            label="Megjelenik a főoldalon"
                            saveChanges={this.props.setFieldValue}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(LoyaltyPointDiscountRuleForm);
